import {ThunkDispatch} from 'redux-thunk';
import {AnyAction, bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {State} from '../../../redux/reducer';
import selectors from '../CommonPage/redux/selectors';
import {layoutSelectors, layoutActions} from '../redux';
import DialogRoutesWrapper from './DialogRoutesWrapper';

const mapStateToProps = (state: State) => ({
   isFetching: selectors.isFetching(state),
   subDialogs: layoutSelectors.getDialogs(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
   closeDialog: bindActionCreators(layoutActions.closeSubDialog, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DialogRoutesWrapper);
